/**
 * Notifications Constants
 * Timezones and helper functions
 */

import type { TimezoneOption, EmailFrequency } from '../types';

// US Timezones
export const TIMEZONES: TimezoneOption[] = [
  { value: 'America/New_York', label: 'Eastern Time (ET)' },
  { value: 'America/Chicago', label: 'Central Time (CT)' },
  { value: 'America/Denver', label: 'Mountain Time (MT)' },
  { value: 'America/Los_Angeles', label: 'Pacific Time (PT)' },
  { value: 'America/Anchorage', label: 'Alaska Time (AKT)' },
  { value: 'Pacific/Honolulu', label: 'Hawaii Time (HT)' },
];

// Default preferences
export const DEFAULT_PREFERENCES = {
  emailEnabled: true,
  emailDigestFrequency: 'daily' as EmailFrequency,
  pushEnabled: false,
  timezone: 'America/New_York',
  notificationWindowStart: 8,
  notificationWindowEnd: 22,
  promoEmailsEnabled: false,
};

// Frequency options for display
export const FREQUENCY_OPTIONS = [
  {
    value: 'immediate' as EmailFrequency,
    labelKey: 'notifications.frequency.immediate',
    label: 'Immediately',
    descKey: 'notifications.frequency.immediateDesc',
    description: 'Get emails right away',
  },
  {
    value: 'daily' as EmailFrequency,
    labelKey: 'notifications.frequency.daily',
    label: 'Daily Digest',
    descKey: 'notifications.frequency.dailyDesc',
    description: 'Once per day summary',
  },
  {
    value: 'weekly' as EmailFrequency,
    labelKey: 'notifications.frequency.weekly',
    label: 'Weekly Digest',
    descKey: 'notifications.frequency.weeklyDesc',
    description: 'Once per week summary',
  },
  {
    value: 'never' as EmailFrequency,
    labelKey: 'notifications.frequency.never',
    label: 'Never',
    descKey: 'notifications.frequency.neverDesc',
    description: 'Disable email digests',
  },
];

/**
 * Format hour to 12-hour format
 */
export function formatHour(hour: number): string {
  if (hour === 0) return '12:00 AM';
  if (hour === 12) return '12:00 PM';
  if (hour < 12) return `${hour}:00 AM`;
  return `${hour - 12}:00 PM`;
}

/**
 * Get timezone label from value
 */
export function getTimezoneLabel(value: string): string {
  const tz = TIMEZONES.find(t => t.value === value);
  return tz?.label || value;
}

/**
 * Rumios multiplier for promo emails subscription
 */
export const PROMO_EMAIL_RUMIOS_MULTIPLIER = 1.5;
